import React from "react";
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";

interface ModalProps {
    modal_title?: string;
    modal_handler: (isOpen: boolean) => void;
    children?: React.ReactNode;
    save_handler?: ()=>void
    other_classes?: string
    is_btn_disable?: boolean,
    showBtns?: boolean
}

const Modal: React.FC<ModalProps> = ({modal_title, modal_handler, children, save_handler,other_classes, is_btn_disable, showBtns = true }) => {

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
            <div className={`${other_classes} bg-white w-11/12 max-w-3xl p-5 rounded-lg shadow-lg`}>
                <h2 className="text-lg font-medium mb-4">{modal_title || ""}</h2>

                {children}

                {showBtns && <div className="flex justify-end mt-4 space-x-2">
                    <Button
                        on_click_handler={()=>modal_handler(false)}
                        btn_label={CONSTANTS.CANCEL_TXT}
                        other_classes="!w-fit px-3 py-2 text-sm !bg-gray-300 !text-black font-normal rounded-md hover:bg-gray-400"
                        />
                    <Button
                        is_disable={is_btn_disable}
                        on_click_handler={save_handler}
                        btn_label={CONSTANTS.SAVE_TXT}
                        other_classes="!w-fit px-3 py-2 text-sm font-normal rounded-md hover:bg-gray-400"
                    />
                </div>}
            </div>
        </div>
    );
};

export default Modal;
